<ng-container *ngIf="visible">
  <button *ngIf="!emailConnected && !showConnectBtns" class="btn btn-primary" (click)="showConnectBtns = true">Connect Your Account</button>
  <ng-container *ngIf="!emailConnected && showConnectBtns">
    <div class="d-flex align-items-center">
      <a href="javascript:void(0)" (click)="gSuiteLogin()" class="btn btn-primary mr-2">G Suite</a>
    </div>
  </ng-container>

  <div class="appointment-card">
    <div class="appointment_box">
      <div class="create_box">
        <h3 class="table-title">Create New Appointment</h3>
        <form [formGroup]="appointment_create">
          <div class="row mt-3">
            <div class="col-sm-4 pr-0">
              <p class="mb-1">Appointment Title</p>
              <input type="text" formControlName="app_title" placeholder="Title" />
            </div>

            <div class="col-sm-4 pr-0">
              <p class="mb-1">Select Project</p>
              <ng-select
                [items]="ProjectList"
                bindLabel="Project_Name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Project"
                [clearable]="true"
                id="lead_category"
                name="lead_category"
                formControlName="project">
                <ng-template ng-option-tmp let-item="item">
                  <div tooltipPosition="top" [pTooltip]="item.Project_Name">{{ item.Project_Name }}</div>
                </ng-template>
              </ng-select>
            </div>

            <div class="col-sm-4">
              <p class="mb-1">Appointment Type</p>
              <ng-select
                [items]="appointment_type"
                bindLabel="tag_name"
                bindValue="tag_name"
                [searchable]="true"
                [multiple]="false"
                formControlName="app_type"
                placeholder="Appointment Type"
                [clearable]="true">
                <ng-template ng-option-tmp let-item="item">
                  <div class="d-flex align-items-center">
                    <p [ngStyle]="{ 'background-color': item.background_color }" class="cal-color"></p>
                    <p tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</p>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <div class="col-sm-6 mt-2">
              <p class="mb-1">Select Agent</p>
              <re-multiSelect
                [options]="originalAssigns"
                formControlName="agent_id"
                optionLabel="full_name"
                optionValue="_id"
                placeholder="Select Agent"
                [isEmail]="true"></re-multiSelect>
            </div>
          </div>

          <div class="row">
            <div class="d-flex align-items-center justify-content-between mt-2 mb-1">
              <p class="_fw-600">
                <img src="assets/img/Peoples_user-business.svg" class="icon_" alt="" />
                Client
              </p>
              <button class="_view-btn p-2 h-auto" type="button" (click)="addclient()" pTooltip="Add Client" tooltipPosition="left">
                <i class="pi pi-plus f-12"></i>
              </button>
            </div>

            <ng-container *ngFor="let client of appointment_client; let i = index">
              <div class="col-sm-4 {{ i > 0 && 'mt-2' }}">
                <p class="mb-1">Name</p>
                <label for="" class="w-100">
                  <re-multiselect
                    [module]="'contacts'"
                    [placeholder]="'Select'"
                    [truncate]="25"
                    [isMultiple]="false"
                    [isClear]="true"
                    [isFullObject]="true"
                    [selected_ids]="client.contactid"
                    [ngModelOptions]="{ standalone: true }"
                    (onUpdate)="contactSelection($event, i)"
                    [style]="{ width: '100%' }">
                  </re-multiselect>
                </label>
              </div>
              <div class="col-sm-3  {{ i > 0 && 'mt-2' }} pl-0">
                <p class="mb-1">Mobile</p>
                <input type="text" placeholder="Mobile" [ngModelOptions]="{ standalone: true }" [(ngModel)]="client.mobile_no" />
              </div>
              <div class="col-sm-4  {{ i > 0 && 'mt-2' }} px-0 position-relative">
                <p class="mb-1">Email</p>
                <i class="pi pi-times remove-client" (click)="removeClient(i)"></i>
                <input type="email" placeholder="Email" [ngModelOptions]="{ standalone: true }" [(ngModel)]="client.email" />
              </div>
            </ng-container>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <p class="_fw-600 my-2">Guest</p>
              <p-chips [(ngModel)]="attendeeList" [ngModelOptions]="{ standalone: true }" (onAdd)="onAddEmail($event)"></p-chips>
              <small class="px-1 f-10">Press enter after typing tag name</small>
            </div>
          </div>
          <div class="row gap-2">
            <div class="d-flex align-items-center justify-content-between my-2 mb-1">
              <p class="_fw-600">
                <img [src]="common_images?.email_overview_icon" class="icon_" alt="" />
                Time & Date
              </p>
            </div>

            <div style="width: 125px">
              <p class="mb-1">Pick a Date</p>
              <p-calendar dateFormat="dd/mm/yy" [firstDayOfWeek]="1" formControlName="pick_date"> </p-calendar>
            </div>

            <div style="width: 210px; padding-left: 0">
              <div style="display: flex; flex-direction: column">
                <p class="mb-1 pl-0">Start Time</p>
                <div class="d-flex gap-2">
                  <div class="col-sm-4 pl-0" style="width: 60px">
                    <ng-select
                      formControlName="start_time_hours"
                      [clearable]="false"
                      [searchable]="true"
                      placeholder="Hr"
                      [items]="hours"
                      (change)="startHourChange()">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0" style="width: 65px">
                    <ng-select
                      formControlName="start_time_minute"
                      [clearable]="false"
                      [searchable]="true"
                      placeholder="Min"
                      [items]="minutes"
                      (change)="startMinuteChange()">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0" style="width: 66px">
                    <ng-select
                      formControlName="start_time_AMPM"
                      [clearable]="false"
                      [searchable]="true"
                      placeholder="AM"
                      [items]="duration"
                      (change)="startHourChange()">
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>

            <div style="width: 225px">
              <div style="display: flex; flex-direction: column">
                <p class="mb-1 pl-0">End Time</p>
                <div class="d-flex gap-2">
                  <div class="col-sm-4 pl-0" style="width: 60px">
                    <ng-select
                      formControlName="end_time_hours"
                      [clearable]="false"
                      [searchable]="true"
                      placeholder="Hr"
                      [items]="hours"
                      (change)="endHourChange()">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0" style="width: 65px">
                    <ng-select
                      formControlName="end_time_minute"
                      [clearable]="false"
                      [searchable]="true"
                      placeholder="Min"
                      [items]="minutes"
                      (change)="endMinuteChange()">
                    </ng-select>
                  </div>
                  <div class="col-sm-4 pl-0" style="width: 66px">
                    <ng-select
                      formControlName="end_time_AMPM"
                      [clearable]="false"
                      [searchable]="true"
                      placeholder="AM"
                      [items]="duration"
                      (change)="endHourChange()">
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <p class="mb-1 pl-0">
                <img class="icon_" src="assets/headerLogin/note.svg" />
                Description
              </p>
              <div class="_paragraph content-inputs">
                <ckeditor class="c-editor" formControlName="app_desc" data="" [editor]="Editor"> </ckeditor>
              </div>
            </div>
          </div>
        </form>
        <div class="flexCenterEnd mt-5">
          <button class="_cancel-btn mr-2" (click)="this.is_submit = false; close(true)">Cancel</button>
          <button class="_outline-btn" [disabled]="is_submit" (click)="is_submit = true; addAppointment()">
            {{ app_details?._id ? 'Update' : 'Save' }}
          </button>
        </div>
        <ng-container *ngIf="is_Exist">
          <div>
            <p class="text-danger">Note</p>
            <ul class="ml-3 mt-2 text-danger">
              <li>An appointment has already been registered for this contact, do you want to create another appointment?</li>
            </ul>
            <div class="flexCenterEnd mt-4">
              <button class="_cancel-btn mr-2" (click)="is_Exist = false; this.is_submit = false">No</button>
              <button class="_outline-btn" (click)="this.checkConnectedUser(this.object_event); is_Exist = false">Yes</button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="is_connected">
          <div>
            <p class="text-danger">Note</p>
            <ng-container *ngIf="dis_connected[0]?._id === Api.getUserId(); else no_id">
              <ul class="ml-3 mt-2 text-danger">
                <li>Please connect your calendar to create appointment.</li>
              </ul>
            </ng-container>
            <ng-template #no_id>
              <div class="ml-2 mt-2">
                <p class="text-danger mb-1">Please connect Calendar.</p>
                <ul *ngFor="let user of dis_connected">
                  <li class="text-danger ml-3">{{ user?.full_name }}</li>
                </ul>
              </div>
            </ng-template>
            <div class="flexCenterEnd mt-4">
              <button class="_outline-btn" (click)="gSuiteLogin()">Connect Your Calendar</button>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="calander_box">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="create-task-dropdown w-250px">
            <ng-select
              *ngIf="calendarAccessUser?.length > 0"
              [items]="calendarAccessUser"
              bindLabel="full_name"
              bindValue="_id"
              [searchable]="true"
              [multiple]="true"
              [(ngModel)]="activeCalendarUser"
              placeholder="Calendar Access User"
              [clearable]="false"
              class="task-contact _select"
              (change)="getUserCalendarDetail()">
              <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <i
                    class="pi pi-times-circle cursor-pointer mr-2 ml-1"
                    (click)="clear(item?._id, 'calendar'); getUserCalendarDetail(selectedProperty, true, item, item?._id)"></i>
                  <p class="ng-value-label">{{ item.full_name }}</p>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <p [ngStyle]="{ 'background-color': item.color }" class="cal-color"></p>
                  <p>{{ item.full_name }}</p>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <ng-select
            [items]="calendar_views"
            [searchable]="true"
            [(ngModel)]="cal_view_grid"
            bindLabel="name"
            bindValue="value"
            placeholder="Select"
            [clearable]="false"
            style="width: 120px"
            (change)="changeToGridView()">
            <ng-template ng-option-tmp let-item="item">
              <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
            </ng-template>
          </ng-select>
        </div>
        <div class="agentCalendar">
          <div class="px-2 d-flex align-items-center">
            <img class="img-24 dark mr-2" [src]="common_images?.calendar" />
            <h5 class="text-dark f-14" style="color: #2d303d">Agent Calendar</h5>
          </div>
          <i class="pi pi-refresh cursor-pointer f-14 refreshIcon"></i>
        </div>
        <full-calendar style="margin-top: -5px" [options]="optional" contentHeight="auto" #fullcalendar class="fcal"> </full-calendar>
      </div>
    </div>
  </div>
</ng-container>

<div class="event_popup_modal">
  <p-dialog
    [(visible)]="event_popup"
    [position]="'center'"
    [styleClass]="'noHeader'"
    [showHeader]="false"
    [style]="{ width: '580px', 'margin-top': '200px' }">
    <div class="row">
      <div class="d-flex justify-content-center">
        <span class="left-box-second d-flex justify-content-center">
          <p class="color-box"></p>
        </span>
        <div class="right-box-prop">
          <h6 class="event-title mb-1">{{ event_popup_detail?.summary?.split('|')[0] }}</h6>
          <p class="f-12">
            {{ event_popup_detail?.start?.dateTime | date: 'EEEE, MMMM dd - hh:mm' }} -
            {{ event_popup_detail?.end?.dateTime | date: 'hh:mm a' }}
          </p>
        </div>
        <div class="crossiconStyle mr-2 cursor-pointer event_poup_close_btn d-flex align-items-center">
          <i class="pi pi-times p-1" (click)="event_popup = false"></i>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="d-flex w-100 mb-2 mt-2">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-bars"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12" [innerHtml]="event_popup_detail?.description"></p>
        </div>
      </div>
      <div class="d-flex w-100">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-bell"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12">30 minutes before</p>
        </div>
      </div>
      <div class="d-flex w-100">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-calendar"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12">
            {{ event_popup_detail?.creator?.full_name ? event_popup_detail?.creator?.full_name : 'Listing' }}
          </p>
        </div>
      </div>
      <div class="d-flex w-100">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-lock"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12 text-capitalize">{{ event_popup_detail?.visibility }}</p>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
